<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">
    <div class="flex flex-wrap xl:flex-nowrap flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
        <div class="relative">
            <input [(ngModel)]="search" type="text" placeholder="Search.." class="pl-8" />
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
        </div>
        <div>
            <input type="text" name="time" id="time" [(ngModel)]="todayDate" [owlDateTime]="date"
                [owlDateTimeTrigger]="date" [selectMode]="'range'" />
            <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange($event)" #date></owl-date-time>
        </div>
    </div>
    <div *ngIf="trips && trips.length" class="flex items-center">
            <h1 class=" text-xs text-nowrap text-left">Showing {{trips.length}} entries
            </h1>
        </div>
        <div></div>
</div>
<div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
    <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
        <div class="flow-root h-full overflow-y-auto">
            <div class="-my-2">
                <div class="inline-block min-w-full py-2 align-middle">
                    <table class="min-w-full table-auto">
            <thead class="bg-zinc-950/5 dark:bg-white/5">
                <tr>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        #</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Action</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Status</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                       Fare</th>
                             <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                       Special Fare</th>
                                            <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Service Area</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Reference ID
                    </th>

                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Member</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Contact No.</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Pickup Time
                    </th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Dropoff Time
                    </th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Pickup Address</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Dropoff Address</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Miles</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Space Type</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        LOS</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Appointment Type</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Created Time</th>
                    <th
                        class="sticky  top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        General Notes</th>
                    <th
                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                        Reserved Time</th>
                </tr>
            </thead>
             <tbody>
                <tr *ngFor="let trip of trips | filter: search | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i = index;"
                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">
                   <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        {{i+1}}
                    </td>
                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                        <div class="flex items-center space-x-2">
                            <!-- Eye icon -->
                            <button [appToolTip]="'Detail'" (click)="openDetailModal(trip)">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                </svg>
                            </button>
                            <div class="h-5 w-px bg-zinc-950/10 dark:bg-white/10"   ></div>
                            
                            <div class="inline-flex relative">
                                <!-- *ngIf="!assign.isJClone" -->
                            
                                <a [appToolTip]="'More Actions'"  *ngIf="!trip.isSelected" href="javascript:void(0)" (click)="showActionButtons(i)"
                                    class="text-main-primary hover:text-main-primary-hover duration-500 ease-linear">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                    </svg>
                                </a>
                                <div (outsideClick)="closeActionMenu($event)" outside-click
                                    *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                                    class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                                    role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                            
                                    <!-- (addAdditionalNote)="addAdditionalNote(assign, i)" -->
                                    <app-trip-action-dropdown [source]="'trips'" [isReserved]="isReserved" class="divide-y divide-zinc-950/10 dark:divide-white/10" [trip]="trip"
                                        (acceptTrips)="acceptTrips($event)"
                                        (notes)="openNotesModal($event)"
                                        (detail)="openDetailModal($event)"
                                        (getMarketplaceTrip)="getMarketplaceTrip($event)"
                                                        (reserveTrip)="reserveTrip($event)"></app-trip-action-dropdown>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                     <span *ngIf="isReserved(trip)" class="badge-warning my-1">Reserved</span>
                    </td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span *ngIf="trip.fareEstimation && trip.fareEstimation.breakdown">
                            ${{ trip.fareEstimation.breakdown.total || 'N/A'}}
                        </span>
                    </td>

                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span >
                            ${{ trip.specialRate}}
                        </span>
                    </td>
 
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span *ngIf="preServiceAreas && preServiceAreas[trip.serviceArea]">
                            {{preServiceAreas[trip.serviceArea].title ? (preServiceAreas[trip.serviceArea].title |
                            titlecase) :
                            'N/A'}}
                        </span>
                    </td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span>
                            {{(trip.reference) || 'N/A'}}-{{trip.suffix}}
                        </span>
                    </td>
    
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        {{trip.member.displayName | titlecase}}
                    </td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap" phoneNumberFormat [phoneNumber]="trip?.pickup?.phoneNumber">
                        {{trip?.pickup.phoneNumber || 'N/A'}}</td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        {{(trip?.pickup.time | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        {{(trip?.destination.time | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</td>

                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        {{(trip?.pickup?.address?.name) || 'N/A'}}</td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        {{trip?.destination?.address?.name || 'N/A'}}</td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                          {{ trip.miles ? (trip.miles | number:'1.2-2') + ' mi' : 'N/A' }}
                    </td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType]">
                            {{(preSpacetypes[trip.spaceType].title | uppercase)|| 'N/A'}}
                        </span>
                    </td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService]">
                            {{(preLevelOfService[trip.levelOfService].title | uppercase)|| 'N/A'}}
                        </span>
                    </td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        <span *ngIf="preAppointmentType && preAppointmentType[trip.appointmentType]">
                            {{(preAppointmentType[trip.appointmentType].title | titlecase) || 'N/A'}}
                        </span>
                    </td>
                    <td
                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                        {{(trip.createdAt | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</td>
                <td class="px-3 py-1 border-b border-zinc-950/10 dark:border-white/10">
                    <div class="w-72 truncate whitespace-nowrap overflow-hidden text-sm-light">
                        {{(trip.generalNotes) || 'N/A'}}
                    </div>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 whitespace-nowrap">
                    <span *ngIf="isReserved(trip)">{{(trip?.reserved?.time | date: 'MM/DD/YYYY HHmm') || 'N/A'}}</span>
                </td>
                </tr>


            </tbody>
        </table>
                </div>
            </div>
        </div>
    </div>
    
    <!-- <div class="mt-2 flex justify-end">
        <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
    </div> -->
</div>
</section>
<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" (closeModal)="tripId = null"></app-trip-detail-modal>
<app-notes-modal *ngIf="memberNotesObj" [notes]="memberNotesObj" (closeModal)="memberNotesObj = null"></app-notes-modal>